import { useEffect, useState } from 'react'
import * as Sentry from '@sentry/nextjs'
import { getWalletENSName } from '@lib/web3/helpers/nftContract'

export const useENSName = (walletId?: string | null) => {
  const [ensName, setEnsName] = useState<string | null>(null)

  useEffect(() => {
    if (walletId === undefined || walletId === null) {
      setEnsName(null)

      return
    }

    getWalletENSName(walletId)
      .then((name) => {
        setEnsName(name)
      })
      .catch(() => {
        Sentry.captureException(
          new Error(`Failed to get ENS name for ${walletId}`)
        )
        setEnsName(null)
      })
  }, [walletId])

  return ensName
}
